import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { OrderChooserModalComponent } from '../components/shared/order-chooser-modal/order-chooser-modal.component';

@Injectable({
  providedIn: 'root'
})
export class OrderChooserModalService {
  constructor(private modalService: NgbModal) { }

  open(): NgbModalRef {
    return this.modalService.open(OrderChooserModalComponent, {
      centered: true,
      size: 'lg',
      windowClass: 'order-chooser-window',
      ariaLabelledBy: 'order-chooser-title'
    });
  }
}
